import md5 from 'js-md5'
import message from '@/components/message';
import qs from 'qs';
import { getToken } from './cookie'

interface Data {
  [key: string]: string | number | Data | Array<Data>
}

interface Resp {
  code: number
  current_time: number
  message: string
  request_id: number
  data: any
}


const request = (url: string, config: RequestInit = {}, mute): Promise<Response> => {
  const timestamp = Date.parse(`${new Date()}`) / 1000
  const key = 'de2d7b2864d3a6b88cb9318677c12f41'
  const sign = md5(`${timestamp}${key}`).toUpperCase()

  const realConfig: RequestInit = {
    headers: {
      timestamp: `${timestamp}`,
      sign,
      'Content-Type': 'application/json',
      Authorization: getToken(),
    },
    ...config,
  }

  return fetch(url, realConfig)
    .then((res: any) => res.json())
    .then((resJson: any) => {
      if (resJson.code !== 200 && resJson.code !== 0) {
        throw resJson
      } else {
        return resJson
      }
    })
    .catch((err) => {
      console.log('mute', mute);
      if (!mute) {
        message.error({
          content: err?.message || '內部錯誤，請稍後重試',
        })
      }
      console.error(err?.message || '內部錯誤，請稍後重試')
      throw err
    })
}

// GET請求
export const get = (url: string, data: Data = {}, mute=false): Promise<Response> => {
  const keysArray = Object.keys(data)
  if (keysArray.length > 0) {
    url += `?${qs.stringify(data, {encode: false, arrayFormat: 'brackets'})}`
    // url += keysArray.map((key) => `${key}=${data[key]}`).join('&')
  }
  return request(url, { method: 'GET' }, mute)
}

// POST請求
export const post = (url: string, data: Data = {}, mute=false): Promise<Response> => {
  return request(url, {
    body: JSON.stringify(data),
    method: 'POST',
  }, mute)
}

const errorCodeNotMessage = [10012, 20205]

const payRequest = (url: string, config: RequestInit = {}): Promise<Resp> => {
  const timestamp = Date.parse(`${new Date()}`) / 1000
  const key = 'B0VwRmcGgKwHmA8zMUgN7g9HJzjBbD5w'
  const sign = md5(`${url.split('?')[0]}${timestamp}${key}`)

  const realConfig: RequestInit = {
    headers: {
      timestamp: `${timestamp}`,
      sign,
      'content-type': 'application/json',
      'session-token': getToken(),
      language: localStorage.getItem('i18nextLng') || 'en',
      region: localStorage.getItem('region') || '',
    },
    ...config,
  }

  return fetch(url, realConfig)
    .then((res: any) => res.json())
    .then((resJson: any) => {
      if (resJson.code !== 200 && resJson.code !== 0) {
        throw resJson
      } else {
        return resJson
      }
    })
    .catch((err) => {
      console.error(err?.message || '內部錯誤，請稍後重試')
      if (errorCodeNotMessage.indexOf(err?.code) === -1) {
        message.error({ content: err?.message || '內部錯誤，請稍後重試' })
      }
      throw err
    })
}

// GET請求
export const payGet = (url: string, data: Data = {}): Promise<Resp> => {
  const keysArray = Object.keys(data)
  if (keysArray.length > 0) {
    url += '?'
    url += keysArray.map((key) => `${key}=${data[key]}`).join('&')
  }
  return payRequest(url, { method: 'GET' })
}

// POST請求
export const payPost = (url: string, data: Data = {}): Promise<Resp> => {
  return payRequest(url, {
    body: JSON.stringify(data),
    method: 'POST',
  })
}
